import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import UpOutlinedSvg from "@ant-design/icons-svg/es/asn/UpOutlined";
import AntdIcon from "../components/AntdIcon";
var UpOutlined = function UpOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: UpOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  UpOutlined.displayName = 'UpOutlined';
}
export default /*#__PURE__*/React.forwardRef(UpOutlined);